import { ExternalLink } from 'lucide-react';

const awards = [
  {
    id: 1,
    title: 'International Travel Awards',
    logo: 'https://goldentreeawards.com/public/logo/international-travel-awards-250x78.png',
    url: 'https://internationaltravelawards.org/',
  },
  {
    id: 2,
    title: 'International Restaurant Awards',
    logo: 'https://goldentreeawards.com/public/logo/international-restaurant-awards-250x78.png',
    url: 'https://internationalrestaurantawards.com/',
  },
  {
    id: 3,
    title: 'International Spa & Beauty Awards',
    logo: 'https://goldentreeawards.com/public/logo/international-spa-beauty-awards-logo-v2.png',
    url: 'https://internationalspabeautyawards.com/',
  },
  {
    id: 4,
    title: 'World 5 Star Hotel Awards',
    logo: 'https://goldentreeawards.com/public/World-5-Star-Awards-logo-web.png',
    url: 'https://world5starhotelwards.com/',
  },
  {
    id: 5,
    title: 'World Beauty Awards',
    logo: 'https://goldentreeawards.com/public/world-beauty-awards-logo-final.png',
    url: 'https://worldbeautyawards.com/',
  },
  {
    id: 6,
    title: 'Arabian Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/arabian-best-of-best-awards-logo.png',
    url: 'https://arabianbestofbestawards.com/',
  },
  {
    id: 7,
    title: 'Europe Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/europe-best-of-best-awards.png',
    url: 'https://europebestofbestawards.com/',
  },
  {
    id: 8,
    title: 'UK Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/uk-best-of-best-awards.png',
    url: 'https://ukbestofbestawards.com/',
  },
  {
    id: 9,
    title: 'Asia Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/asia-best-of-best-awards.png',
    url: 'https://asiabestofbestawards.com/',
  },
  {
    id: 10,
    title: 'Oceania Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/oceania-best-of-best-awards.png',
    url: 'https://oceaniabestofbestawards.com/',
  },
  {
    id: 11,
    title: 'America Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/america-best-of-best-awards.png',
    url: 'https://americabestofbestawards.com/',
  },
  {
    id: 12,
    title: 'Africa Best of Best Awards',
    logo: 'https://goldentreeawards.com/public/logo/africa-best-of-best-awards.png',
    url: 'https://africabestofbestawards.com/',
  },
  {
    id: 13,
    title: 'World Technology Awards',
    logo: 'https://goldentreeawards.com/public/logo/world-technology-awards-web.png',
    url: 'https://worldtechnologyawards.com/',
  },
  {
    id: 14,
    title: 'World Real Estate Excellence Awards',
    logo: 'https://goldentreeawards.com/public/world-real-estate-excellence-awards-logo.png',
    url: 'https://worldrealestateaward.com/',
  },
  {
    id: 15,
    title: 'World CEO Awards',
    logo: 'https://goldentreeawards.com/public/logo/world-ceo-300-v2.png',
    url: 'https://worldceoawards.com/',
  },
  {
    id: 16,
    title: 'World GM Awards',
    logo: 'https://goldentreeawards.com/public/logo/world-gm-v2-300.png',
    url: 'https://worldgmawards.com/',
  },
  {
    id: 17,
    title: 'Golden Entrepreneur Awards',
    logo: 'https://goldentreeawards.com/public/logo/golden-entrepreneur-awards-web.png',
    url: 'https://goldenentrepreneurawards.com/',
  },
  {
    id: 18,
    title: 'Golden Women Awards',
    logo: 'https://goldentreeawards.com/public/logo/golden-women-awards-web.png',
    url: 'https://goldenwomenawards.com/',
  },
];

const events = [
  {
    id: 19,
    title: 'World AI Expo',
    logo: 'https://worldaiexpo.io/wp-content/uploads/2026/01/logo.webp',
    url: 'https://worldaiexpo.io/',
  },
  {
    id: 20,
    title: 'World Entrepreneur Investor Summit',
    logo: 'https://entrepreneurinvestorsummit.com/assets/images/entrepreneurinvestorsummit.png',
    url: 'https://entrepreneurinvestorsummit.com/',
  },
  {
    id: 21,
    title: 'World Study Expo',
    logo: 'https://worldstudyexpo.com/education/wp-content/uploads/2025/09/886fe707151bb0c88223a598085f1a464e981519.png',
    url: 'https://worldstudyexpo.com/',
  },
];

export const ProgramsSection = () => {
  return (
    <section data-testid="programs-section" className="py-24 bg-[#0a0a0a]">
      <div className="w-full px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Our Programs</p>
          <h2 className="font-montserrat text-3xl sm:text-4xl lg:text-5xl text-white mb-4">
            Awards & <span className="gradient-gold">Events</span>
          </h2>
          <p className="font-google-sans text-[#A1A1AA] max-w-2xl mx-auto">
            Organized by Golden Tree Events - World-class award programs, summits, and exhibitions
          </p>
        </div>

        {/* Awards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {awards.map((award) => (
            <a
              key={award.id}
              href={award.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`award-${award.id}`}
              className="group relative overflow-hidden bg-gradient-to-b from-[#1a1a2e] to-[#0a0a15] border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-300 rounded-lg"
            >
              {/* Logo Container */}
              <div className="p-4 flex items-center justify-center h-32 bg-gradient-to-b from-white/5 to-transparent">
                <img
                  src={award.logo}
                  alt={award.title}
                  className="max-h-24 max-w-full object-contain transition-transform duration-300 group-hover:scale-110"
                />
              </div>

              {/* External Link Icon on Hover */}
              <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <ExternalLink className="w-4 h-4 text-[#D4AF37]" />
              </div>
            </a>
          ))}
        </div>

        {/* Events Section */}
        <div className="mt-12">
          <h3 className="font-montserrat text-2xl text-white text-center mb-8">
            Summits & <span className="gradient-gold">Expos</span>
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {events.map((event) => (
              <a
                key={event.id}
                href={event.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`event-${event.id}`}
                className="group relative overflow-hidden bg-gradient-to-b from-[#1a1a2e] to-[#0a0a15] border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-300 rounded-lg"
              >
                {/* Logo Container */}
                <div className="p-6 flex items-center justify-center h-40 bg-gradient-to-b from-white/5 to-transparent">
                  <img
                    src={event.logo}
                    alt={event.title}
                    className="max-h-28 max-w-full object-contain transition-transform duration-300 group-hover:scale-110"
                  />
                </div>

                {/* External Link Icon on Hover */}
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ExternalLink className="w-4 h-4 text-[#D4AF37]" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
